import styles from './Grid.module.scss';
import type { ComponentType, ReactNode } from 'react';
import type { HtmlTagName, ComponentOrHtmlProps } from 'utils/types';
import classNames from 'classnames';

type Props<T> = {
  as?: T;
  className?: string;
  align?:
  | 'left'
  | 'center'
  | 'right'
  | 'around'
  | 'between'
  ;
  valign?:
  | 'center'
  | 'bottom'
  ;
  children?: ReactNode;
} & ComponentOrHtmlProps<T>;

function Row<T extends HtmlTagName = 'div'>(props: Props<T>): React.JSX.Element;
function Row<T extends ComponentType<any>>(props: Props<T>): React.JSX.Element;
function Row({ as: Tag = 'div', className, align, valign, children, ...attributes }: Props<any>) {
  const cssClasses = classNames(
    styles.row,
    {
      [styles.justifyContentStart]: align === 'left',
      [styles.justifyContentCenter]: align === 'center',
      [styles.justifyContentEnd]: align === 'right',
      [styles.justifyContentAround]: align === 'around',
      [styles.justifyContentBetween]: align === 'between',
      [styles.alignItemsCenter]: valign === 'center',
      [styles.alignItemsEnd]: valign === 'bottom',
    },
    className,
  );

  return (
    <Tag className={cssClasses} {...attributes}>
      {children}
    </Tag>
  );
}

export default Row;
